module.exports = __webpack_public_path__ + "static/media/Samsung.7a352181.png";